module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "position": "relative",
      "display": "inline-block",
      "width": "auto",
      "margin": "0",
      "padding": "0"
    }
  }, [_c('div', {
    staticClass: "modal-trigger"
  }, [_vm._v("\n    " + _vm._s(_vm.user.username) + "\n    "), _c('div', {
    staticClass: "user-modal",
    style: ('top: ' + _vm.y + 'px; left: ' + _vm.x + 'px;')
  }, [_vm._v("\n      ,\n      "), _c('v-layout', {
    staticClass: "text-xs-right",
    attrs: {
      "row": ""
    }
  }, [_vm._v(", "), _c('img', {
    staticClass: "pic-big",
    attrs: {
      "src": _vm.user.image
    }
  }), _vm._v(",\n        "), _c('div', {
    staticClass: "user-modal-header"
  }, [_vm._v("\n          ,\n          "), _c('div', {
    staticClass: "user-modal-name"
  }, [_vm._v(_vm._s(_vm.user.username))]), _vm._v("\n          ,\n          "), _c('div', {
    staticClass: "user-modal-detail"
  }, [_c('b', [_vm._v("2.8k")]), _vm._v(" Followers")]), _vm._v("\n          ,\n        ")]), _vm._v("\n        , ")]), _vm._v(",\n      "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_vm._v(", "), _c('button', {
    staticClass: "user-modal-btn"
  }, [_vm._v("Follow")]), _vm._v(",\n        "), _c('button', {
    staticClass: "user-modal-btn"
  }, [_vm._v("Message")]), _vm._v(", ")]), _vm._v(",\n    ")], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-60b24daa","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/chat/usermodal.vue
// module id = 1743
// module chunks = 180